/* Amana Print Studio — Theme Scripts */

(function () {
  'use strict';

  function initStickyHeader() {
    var header = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
    if (!header) return;
    var threshold = 80;
    function onScroll() {
      if (window.scrollY > threshold) {
        header.classList.add('amana-scrolled');
      } else {
        header.classList.remove('amana-scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initScrollReveal() {
    var targets = document.querySelectorAll('.amana-reveal, .amana-reveal-left, .amana-reveal-right');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    targets.forEach(function (el) { observer.observe(el); });
  }

  function initMaterialTabs() {
    var tabs = document.querySelectorAll('.amana-tab-btn');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var container = tab.closest('.amana-materials, [data-tabs-container]') || document;
        var targetPanel = tab.getAttribute('data-tab');
        container.querySelectorAll('.amana-tab-btn').forEach(function (t) { t.classList.remove('is-active'); });
        container.querySelectorAll('.amana-tab-panel').forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var panel = container.querySelector('[data-panel="' + targetPanel + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  }

  function initCounters() {
    var counters = document.querySelectorAll('[data-count-to]');
    if (!counters.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseInt(el.getAttribute('data-count-to'), 10);
          var duration = 1800;
          var start = 0;
          var startTime = null;
          function step(timestamp) {
            if (!startTime) startTime = timestamp;
            var progress = Math.min((timestamp - startTime) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = Math.floor(eased * target).toLocaleString();
            if (progress < 1) requestAnimationFrame(step);
            else el.textContent = target.toLocaleString();
          }
          requestAnimationFrame(step);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });
    counters.forEach(function (el) { observer.observe(el); });
  }

  function initHeroParallax() {
    var bg = document.querySelector('.amana-hero__bg');
    if (!bg) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.addEventListener('scroll', function () {
      var scrollY = window.scrollY;
      if (scrollY < window.innerHeight) {
        bg.style.transform = 'translateY(' + (scrollY * 0.3) + 'px)';
      }
    }, { passive: true });
  }

  function initProductCardHover() {
    var cards = document.querySelectorAll('.amana-product-card__media');
    cards.forEach(function (card) {
      var primary = card.querySelector('.amana-product-card__img--primary');
      var secondary = card.querySelector('.amana-product-card__img--secondary');
      if (!secondary) return;
      card.addEventListener('mouseenter', function () {
        if (primary) primary.style.opacity = '0';
        secondary.style.opacity = '1';
      });
      card.addEventListener('mouseleave', function () {
        if (primary) primary.style.opacity = '1';
        secondary.style.opacity = '0';
      });
    });
  }

  function initDetailImageSwitch() {
    var details = document.querySelectorAll('.amana-product-feature__detail');
    var mainImg = document.querySelector('.amana-product-feature__main-img');
    if (!details.length || !mainImg) return;
    details.forEach(function (detail) {
      detail.addEventListener('click', function () {
        var src = detail.querySelector('img') && detail.querySelector('img').src;
        if (src) {
          var oldSrc = mainImg.src;
          mainImg.style.opacity = '0';
          setTimeout(function () {
            mainImg.src = src;
            mainImg.style.transition = 'opacity 0.3s ease';
            mainImg.style.opacity = '1';
          }, 200);
          detail.querySelector('img').src = oldSrc;
        }
      });
    });
  }

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    initStickyHeader();
    initScrollReveal();
    initMaterialTabs();
    initCounters();
    initHeroParallax();
    initProductCardHover();
    initDetailImageSwitch();
  });
})();
